/**
 * Navigation Module
 * Mobile menu, navigation, dropdowns, and tab view
 */

import { isMobile, isTab } from "./utils.js";
import { gsap } from "gsap";

export function initNavigation() {
  const mobileToggle = document.querySelector(".mobile-menu-toggle");
  const mainMenu = document.querySelector(".main-menu");
  const menuItemsWithChildren = document.querySelectorAll(
    ".menu-item-has-children"
  );
  const navigation = document.querySelector(".primary-navigation");

  // Mobile menu toggle
  if (mobileToggle && mainMenu) {
    mobileToggle.addEventListener("click", (e) => {
      e.preventDefault();
      toggleMobileMenu(mobileToggle, mainMenu);
    });
  }

  // Mobile submenu toggle dengan trigger pada ::after area
  menuItemsWithChildren.forEach((item) => {
    const link = item.querySelector("a");
    const submenu = item.querySelector(".sub-menu");

    if (link && submenu) {
      link.addEventListener("click", (e) => {
        const linkRect = link.getBoundingClientRect();
        const clickX = e.clientX - linkRect.left;
        const linkWidth = linkRect.width;

        const afterAreaWidth = 40;
        const isClickOnAfter = clickX > (linkWidth - afterAreaWidth);

        if (isClickOnAfter && (isMobile() || isTab())) {
          e.preventDefault();
          link.classList.add("active");
          toggleSubmenu(item, submenu, menuItemsWithChildren);
        }
      });
    }
  });

  // Close mobile menu when clicking outside
  document.addEventListener("click", (e) => {
    if (
      (isMobile() || isTab()) &&
      navigation &&
      !e.target.closest(".primary-navigation")
    ) {
      closeMobileMenu(mobileToggle, mainMenu, menuItemsWithChildren);
    }
  });

  // Handle window resize
  window.addEventListener("resize", () => {
    if (!isMobile() && !isTab()) {
      resetMobileMenu(mobileToggle, mainMenu, menuItemsWithChildren);
    }
  });

  initDropdownAnimations();
  initTabView();
}

function toggleMobileMenu(toggle, menu) {
  toggle.classList.toggle("active");
  menu.classList.toggle("active");
}

function toggleSubmenu(item, submenu, menuItemsWithChildren) {
  const isActive = item.classList.contains("active");

  // Close other submenus at the same level
  const siblings = item.parentElement.children;
  Array.from(siblings).forEach((sibling) => {
    if (
      sibling !== item &&
      sibling.classList.contains("menu-item-has-children")
    ) {
      sibling.classList.remove("active");
    }
  });

  item.classList.toggle("active");
}

function closeMobileMenu(toggle, menu, menuItems) {
  if (toggle) toggle.classList.remove("active");
  if (menu) menu.classList.remove("active");

  menuItems.forEach((item) => {
    item.classList.remove("active");
  });
}

function resetMobileMenu(toggle, menu, menuItems) {
  if (toggle) toggle.classList.remove("active");
  if (menu) {
    menu.classList.remove("active");
    gsap.set(menu, { maxHeight: "none", opacity: 1 });
  }

  menuItems.forEach((item) => {
    item.classList.remove("active");
    const submenu = item.querySelector(".sub-menu");
    if (submenu) {
      gsap.set(submenu, { maxHeight: "none" });
    }
  });
}

function initDropdownAnimations() {
  const menuItems = document.querySelectorAll(".menu-item-has-children");

  menuItems.forEach((item) => {
    const submenu = item.querySelector(".sub-menu");
    if (submenu && !isMobile()) {
      item.addEventListener("mouseenter", () => {
        // Dropdown animation can be added here
      });

      item.addEventListener("mouseleave", () => {
        // Dropdown animation can be added here
      });
    }
  });
}

function initTabView() {
  if (isTab()) {
    console.log("tab View");

    let existingMenuTab = document.querySelector(".headerBasic__menuTab");
    if (existingMenuTab) {
      existingMenuTab.remove();
    }

    const newMenuDiv = document.createElement("div");
    newMenuDiv.className = "headerBasic__menuTab";

    const headerBottom = document.querySelector(".headerBasic__bottom");

    if (headerBottom) {
      headerBottom.insertAdjacentElement("afterend", newMenuDiv);

      const menuSearchElements = document.querySelectorAll(".headerBasic__menu");
      menuSearchElements.forEach((element) => {
        newMenuDiv.appendChild(element);
      });
    } else {
      console.warn(".headerBasic__bottom tidak ditemukan");
    }
  }

  if (isMobile()) {
    console.log("Mobile View");

    let existingMenuTab = document.querySelector(".headerBasic__menuTab");
    if (existingMenuTab) {
      existingMenuTab.remove();
    }

    const newMenuDiv = document.createElement("div");
    newMenuDiv.className = "headerBasic__menuTab";

    const headerBottom = document.querySelector(".headerBasic__bottom");
    const mobileToggle = document.querySelector(".headerBasic__mobile");

    if (mobileToggle) {
      mobileToggle.addEventListener("click", (e) => {
        e.preventDefault();
        newMenuDiv.classList.toggle("show");
        document.body.classList.toggle("no-scroll");
        window.scrollTo(0, 0);
      });
    }

    if (headerBottom) {
      headerBottom.insertAdjacentElement("afterend", newMenuDiv);

      const menuSearchElements = document.querySelectorAll(".headerBasic__menu");
      menuSearchElements.forEach((element) => {
        newMenuDiv.appendChild(element);
      });

      const cardLangElement = document.querySelector(".cardLang");
      if (cardLangElement && menuSearchElements.length > 0) {
        const lastMenu = menuSearchElements[menuSearchElements.length - 1];
        lastMenu.appendChild(cardLangElement);
      }

      const infoDiv = document.createElement("div");
      infoDiv.className = "headerBasic__info";
      newMenuDiv.appendChild(infoDiv);

      const infosElement = document.querySelector(".headerBasic__infos");
      if (infosElement) {
        infoDiv.appendChild(infosElement);
      }

      const sosmedElement = document.querySelector(".headerBasic__sosmed");
      if (sosmedElement) {
        infoDiv.appendChild(sosmedElement);
      }
    } else {
      console.warn(".headerBasic__bottom tidak ditemukan");
    }
  }
}
